import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from '../../components/ui/FormField';
import type { SchemaFieldProps } from '../types';

/**
 * Custom SchemaForm widget for an event template's `defaultAttendance`. The
 * column is a nullable boolean, but the UX is tri-state: maybe (null) / yes
 * (true) / no (false). The default boolean widget (a ToggleSwitch) can't
 * represent the null state, so this override preserves the legacy select +
 * help text exactly. value is boolean | null.
 */
const DefaultAttendanceField: React.FC<SchemaFieldProps> = ({ field, value, onChange, error }) => {
  const { t } = useTranslation();
  const selectValue = value === true ? 'yes' : value === false ? 'no' : 'null';

  return (
    <FormField
      htmlFor="sf-defaultAttendance"
      label={t(field.labelKey, field.name)}
      required={field.required}
      error={error}
      helperText={t('events.defaultAttendanceHelp')}
    >
      <select
        id="sf-defaultAttendance"
        value={selectValue}
        onChange={(e) => {
          const val = e.target.value;
          onChange(val === 'yes' ? true : val === 'no' ? false : null);
        }}
      >
        <option value="null">{t('common.maybe')} (?)</option>
        <option value="yes">{t('common.yes')}</option>
        <option value="no">{t('common.no')}</option>
      </select>
    </FormField>
  );
};

export default DefaultAttendanceField;
